/** Shared planning reserve for both bank summaries and battery runtime badges. */
export function reserveSocForChemistry(chemistry: string | undefined): number {
  switch (chemistry) {
    case "agm":
    case "lead-acid":
    case "gel":
      return 0.5;
    case "lifepo4":
    default:
      return 0.2;
  }
}
/** Initial state of charge shared by the system budget and battery cards. */
export const DEFAULT_SOC = 0.7;
